// extracted by mini-css-extract-plugin
module.exports = {"flowModalWrapper":"BlacklistApplyModal_flowModalWrapper__5fQoK"};